import { Box, Breadcrumbs, Button, FormControl, Grid, InputLabel, Link, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import { KeyboardBackspace, NavigateNext, PrintOutlined } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
// import DateRangePickerTDSAT from "../DateRangePickerTDSAT";
import CircularCenteredLoader from "features/common/CircularCenteredLoader";
import validateDateAndFormat from "utils/validateDateAndFormat";
import fileDownload from "js-file-download";
import { getDisposalList, printDisposalReport } from "features/Tdsat/API/TdsatApi";
import DateRangePickerTDSAT from "features/Tdsat/DateRangePickerTDSAT";
import CaseTypeInput from "features/Tdsat/components/CaseTypeInput";

const useStyles = makeStyles((theme)=>({
  filtersContainer: {
    padding: '1rem', 
    borderBottom: '1px solid black', 
    display: 'flex', 
    gap: '15px', 
    justifyContent:'center',
    // width: '80%',
    margin: 'auto',
  },
  buttonPrint: {
    borderRadius: '0.5rem',
    border: '1px solid #AAAFB9',
    background: '#fff',
    padding: '0.5rem 1rem',
  },
  tableHeadItem:{
		// color: 'grey',
		fontFamily: 'Satoshi-Bold',
    wordBreak: 'break-word',
	},
	tableRowValue: {
		// color: '#858D98',
		fontSize: '0.9375rem',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
	},
	valuePaper: {
		padding: "1.5rem 8px",
		cursor: "pointer",
		boxShadow: "none",
		width: "100%",
		border: "1px solid #E0E0E0",
		"&:hover": {
			background: "#E5F6EF",
			'& $downloadButton': {
				visibility: 'visible',
			}
		},
		[theme.breakpoints.down("sm")]: {
			textAlign: "center",
		},
	},
}))

export default function DisposalReport({handleGoBack}) {
  const classes = useStyles();

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [disposalList, setDisposalList] = useState([]);
	const [caseType, setCaseType] = useState('ADR');

  const spacing = [1,1,2,2,1,1,2,2];
  const tableHeadings = ['Sr. No.','Case No.','Applicant & Respondent Name','Petitioner Advocate','Date of Filing','Date of Disposed','Dipose Nature',`Hon'ble Judges`];
	const CASE_TYPE = ["ADR", "AERA", "BA", "BP", "CA", "EA", "TA", "TP", "All Cases"];


  const processResponse = (data,index) => {
    const item = data;
    const arr = [
      index+1, 
      item?.case_number,  
			item?.applicant_and_respondent,
      item?.petioner_advocate?.join(' \n'),
      validateDateAndFormat(item?.date_of_filing,"dd/MM/y"), 
      validateDateAndFormat(item?.date_of_disposed,"dd/MM/y"), 
      item?.disposal_nature,
      item?.honble_judges?.join(' \n'),
    ];
    return arr;
  }

  const reload = () => {
		setLoading(true);
		getDisposalList(caseType,validateDateAndFormat(startDate,'dd-MM-yyyy'),validateDateAndFormat(endDate,'dd-MM-yyyy'))
    .then((res)=>{
      const response = res?.data?.results || [];
      setDisposalList(response);
      // const processedResponse = processResponse(response);
      // let count = res?.data?.count;
      // let t = parseInt(count / PAGE_SIZE);
      // let r = count % PAGE_SIZE;
      // let total = t + (r > 0 ? 1 : 0);
      // setTotalPages(total);
      setLoading(false);
    })
    .catch((error)=>{
      console.log('Error: ',error);
      setLoading(false)
    })
  }

  useEffect(()=>{
    if((startDate && endDate) || (!startDate && !endDate) || caseType){
      reload();
    }
  },[startDate,endDate,caseType])

  const handlePrintReport = () => {
    printDisposalReport(caseType,validateDateAndFormat(startDate, 'dd-MM-yyyy'),validateDateAndFormat(endDate, 'dd-MM-yyyy')).then((res)=>{
      // console.log(res);
      fileDownload(
        res.data,
        (startDate && endDate) ? `DisposalReport_${validateDateAndFormat(startDate, 'dd-MM-yyyy')}_to_${validateDateAndFormat(endDate, 'dd-MM-yyyy')}.pdf` : 'DisposalReport.pdf'
      );
    }).catch((error)=>{
      console.log(error);
    })
  }

  return (
    <Box>
      <Typography style={{fontSize:'1.5rem', padding:'2rem'}}>
        Disposal Report
      </Typography>
      <Box style={{backgroundColor:'white'}}>
        <Box style={{height:'1rem'}}></Box>
        <Box className={classes.filtersContainer} style={{justifyContent:'space-between'}}>
          <CaseTypeInput
            name="case_type"
            label="Case Type"
            onChange={(e)=> setCaseType(e.target.value || 'All Cases')}
            caseType={caseType}
            isRequired={true}
            size="small"
            formControlStyles={{maxWidth:'28%'}}
          />
          <DateRangePickerTDSAT startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate}/>
          <Button
            className={classes.buttonPrint}
            size="small"
            endIcon={<PrintOutlined/>}
            onClick={handlePrintReport}
          >
            Print Report
          </Button>
        </Box>
        <Box>
          <Box style={{height: '2rem'}}/>
          <Grid container style={{ rowGap: "8px" }}>
            <Box style={{padding:'1.5rem 8px', width: '100%'}}>
              <Grid container spacing={1} justifyContent="flex-start">
                {tableHeadings.map((heading,index)=>{
                  return (
                    <Grid key={index} item xs sm={spacing[index]}>
                      <Typography className={classes.tableHeadItem}>
                        {heading}
                      </Typography>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
            {loading ? (
              <Box style={{margin:'auto',width:'100%',padding:'2rem 0'}}>
                <CircularCenteredLoader/>
              </Box>
            ) : (
              disposalList.length !== 0 ? (
                disposalList.map((dispute,index) => {
                  const processedDispute = processResponse(dispute,index);
                  return (
                    <Box key={index} className={classes.valuePaper}>
                      <Grid container spacing={1} justifyContent="flex-start">
                        {processedDispute.map((item,index)=>{
                          return (
                            <Grid key={index} item xs sm={spacing[index]}>
                              <Typography className={classes.tableRowValue}>
                                {item}
                              </Typography>
                            </Grid>
                          )
                        })}
                      </Grid>
                    </Box>
                  );
                })
              ) : (
                <Grid container justify="center">
                  <Grid item>
                    <Box textAlign="center">
                      <Typography
                        style={{
                          padding: '2rem 8px',
                          textAlign: 'center',
                          fontSize: '1.5rem'
                        }}
                      >
                        No disposed case is found for this criteria.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )
            )}
            {/* {disposalList.length !== 0 && (
              <Box style={{padding:'16px'}}>
                <Pagination color="primary" count={totalPages} page={page} onChange={handlePageChange}/>
              </Box>
            )} */}
          </Grid>
        </Box>
      </Box>
    </Box>
  )
}